"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANGUAGE_COOKIE_LIFETIME = exports.appWithI18Next = void 0;
/// <reference types="./next-global" />
var appWithI18Next_1 = require("./appWithI18Next");
Object.defineProperty(exports, "appWithI18Next", { enumerable: true, get: function () { return appWithI18Next_1.appWithI18Next; } });
exports.LANGUAGE_COOKIE_LIFETIME = 365 * 24 * 3600; // on year
//# sourceMappingURL=index.js.map